// src/admin/views/EventView.js
import { useState } from 'react'
import moment from 'moment'
import '../../styles/admin.css'
import ConfirmationModal from '../components/ConfirmationModal'
import PageHeader from '../components/PageHeader'
import ToggleSwitch from '../components/ToggleSwitch'

function EventView({
  eventData,
  orgName,
  handleChange,
  handleSubmit,
  handleDelete,
  handleCancel,
  handleFinalize,
  handleUnlock,
  isCalculating,
  calculationProgress,
  courses,
}) {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showFinalizeConfirmation, setShowFinalizeConfirmation] = useState(false)
  const [showUnlockConfirmation, setShowUnlockConfirmation] = useState(false)

  const onConfirmFinalize = () => {
    handleFinalize()
    setShowFinalizeConfirmation(false)
  }

  const onConfirmUnlock = () => {
    handleUnlock()
    setShowUnlockConfirmation(false)
  }

  const isFinalized = eventData.finalized
  const isArchive = eventData.eventDate && moment(eventData.eventDate).year() < moment().year()

  return (
    <>
      <PageHeader pageName={'Event Info'} backTo={isArchive ? '/admin/events/archive' : '/admin/events'} />
      <div className="admin-card-container">
        <div className="admin-card">
          <form onSubmit={handleSubmit}>
            <div
              className="admin-input-group"
              style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '10px 20px', alignItems: 'center' }}
            >
              <label className="admin-label" style={{ marginBottom: 0 }}>
                Organization
              </label>
              <div style={{ color: '#4a5568', fontWeight: 'bold' }}>{orgName || ''}</div>
              <input type="hidden" name="orgId" value={eventData.orgId || ''} />
              <label className="admin-label" style={{ marginBottom: 0 }}>
                Season
              </label>
              <div style={{ color: '#4a5568', fontWeight: 'bold' }}>
                {eventData.eventDate ? eventData.eventDate.substring(0, 4) : ''}
              </div>
              {eventData.eventId && (
                <>
                  <label className="admin-label" style={{ marginBottom: 0 }}>
                    Event ID
                  </label>
                  <div style={{ color: '#4a5568', fontWeight: 'bold' }}>{eventData.eventId}</div>
                  <label className="admin-label" style={{ marginBottom: 0 }}>
                    Event Link
                  </label>
                  <div style={{ color: '#4a5568', fontSize: '.75rem', fontWeight: 'bold' }}>{window.location.origin}/event/signin?eventId={eventData.eventId}</div>
                </>
              )}
              {isFinalized && (
                <>
                  <label className="admin-label" style={{ marginBottom: 0 }}>
                    Status
                  </label>
                  <div style={{ color: '#e53e3e', fontWeight: 'bold' }}>FINALIZED</div>
                </>
              )}
            </div>

            <div className="admin-input-group">
              <label htmlFor="eventDate" className="admin-label">
                Event Date
              </label>
              <input
                type="date"
                id="eventDate"
                name="eventDate"
                className="admin-input"
                value={eventData.eventDate}
                onChange={handleChange}
                required
                disabled={isFinalized}
              />
            </div>

            <div className="admin-input-group">
              <label htmlFor="courseId" className="admin-label">
                Course
              </label>
              <select
                id="courseId"
                name="courseId"
                className="admin-input"
                value={eventData.courseId || ''}
                onChange={handleChange}
                required
                disabled={isFinalized}
              >
                <option value="">Select a Course</option>
                {courses.map((course) => (
                  <option key={course.courseId} value={course.courseId}>
                    {course.courseName}
                  </option>
                ))}
              </select>
            </div>

            <div className="admin-input-group">
              <label htmlFor="eventCode" className="admin-label">
                Event Code
              </label>
              <input
                type="text"
                id="eventCode"
                name="eventCode"
                className="admin-input"
                value={eventData.eventCode || ''}
                onChange={handleChange}
                maxLength={18}
                disabled={isFinalized}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px', marginBottom: '20px' }}>
              <ToggleSwitch
                label="Competition"
                name="competition"
                checked={eventData?.competition}
                onChange={handleChange}
                disabled={isFinalized}
              />
              <ToggleSwitch
                label="Count for Hcp"
                name="countForHcp"
                checked={eventData?.countForHcp}
                onChange={handleChange}
                disabled={isFinalized}
              />
              <ToggleSwitch
                label="Rainout"
                name="rainout"
                checked={eventData?.rainout}
                onChange={handleChange}
                disabled={isFinalized}
              />
            </div>

            <div className="admin-button-group">
              {eventData.eventId && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowConfirmation(true)}
                  style={{ marginRight: 'auto' }}
                  disabled={isFinalized}
                >
                  Delete
                </button>
              )}

              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Cancel
              </button>
              {!isFinalized && (
                <button type="submit" className="btn btn-primary">
                  Save Event
                </button>
              )}
            </div>

            {eventData.eventId && (
              <div style={{ marginTop: '20px' }}>
                {isCalculating && (
                  <div style={{ marginBottom: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px', fontSize: '0.9rem' }}>
                      <span>{calculationProgress > 0 ? 'Calculating Handicaps...' : 'Preparing calculation...'}</span>
                      <span>{calculationProgress}%</span>
                    </div>
                    <div style={{ width: '100%', height: '10px', backgroundColor: '#e2e8f0', borderRadius: '5px', overflow: 'hidden' }}>
                      <div
                        style={{
                          width: `${calculationProgress}%`,
                          height: '100%',
                          backgroundColor: '#3182ce',
                          transition: 'width 0.3s ease-in-out',
                        }}
                      />
                    </div>
                  </div>
                )}
                {!isFinalized ? (
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => setShowFinalizeConfirmation(true)}
                    type="button"
                    disabled={isCalculating}
                  >
                    {isCalculating ? 'Calculating...' : 'Finalize Event'}
                  </button>
                ) : (
                  <button
                    className="btn btn-warning"
                    style={{ width: '100%', backgroundColor: '#d69e2e', color: 'white' }}
                    onClick={() => setShowUnlockConfirmation(true)}
                    type="button"
                  >
                    Unlock Event
                  </button>
                )}
              </div>
            )}
          </form>
        </div>

        <ConfirmationModal
          questionText="Are you sure you want to delete this event? Doing so will delete all associated round data. Type DELETE to confirm."
          showConfirmation={showConfirmation}
          setShowConfirmation={setShowConfirmation}
          onConfirm={handleDelete}
        />

        <ConfirmationModal
          questionText="Are you sure you want to finalize this event? This will lock scores and calculate final results."
          showConfirmation={showFinalizeConfirmation}
          setShowConfirmation={setShowFinalizeConfirmation}
          onConfirm={onConfirmFinalize}
          confirmationWord="FINAL"
          accentColor="#2f855a"
        />

        <ConfirmationModal
          questionText="Are you sure you want to unlock this event? This will allow editing of scores and event details."
          showConfirmation={showUnlockConfirmation}
          setShowConfirmation={setShowUnlockConfirmation}
          onConfirm={onConfirmUnlock}
          confirmationWord="UNLOCK"
          accentColor="#d69e2e"
        />
      </div>
    </>
  )
}

export default EventView
